import { format, parseISO } from 'date-fns'

export const formatISO = (dateString: string, formatString: string) =>
  format(parseISO(dateString), formatString)
